import React, { useState, useEffect } from "react";
import {TabPane, Button, Table } from "reactstrap";
import "./index.css";
import ApiCaller from "../../../../api/apiCaller";
import moment from "moment";
import "moment/locale/vi";
import t from "utils/Lang";

interface SiteChangeLogTabProps {
  isView: boolean;
  siteId: any;
}

export default function SiteChangeLogTab({
  isView,
  siteId,
}: SiteChangeLogTabProps) {
  const [logs, setLogs] = useState<Array<any>>([]);
  const [totalLog, setTotalLog] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [isLoadLog, setIsLoadLog] = useState<boolean>(false);

  const getLogs = async () => {
    setIsLoadLog(true);
    const uri = `site_status_change_log/?q=(page:${currentPage},page_size:10,filters:!((col:site_id,opr:eq,value:${siteId})))`;
    const res = await ApiCaller.get(uri);
    if (res?.result) {
      setLogs([...logs, ...res?.result]);
      setTotalLog(res?.count);
      setIsLoadLog(false);
    }
  };

  const loadMoreLogs = () => {
    setCurrentPage(currentPage + 1);
  };

  const actionName = (actionType: string) => {
    let name = "";
    switch (actionType) {
      case "create":
        name = "Tạo mới";
        break;
      case "update":
        name = "Cập nhật";
        break;
      case "delete":
        name = "Xoá";
        break;
      case "change_status":
        name = "Đổi trạng thái";
        break;
    }
    return name;
  };

  // useEffect(() => {
  //   if (siteId) {
  //     getLogs();
  //   }
  // }, []);

  useEffect(() => {
    if (siteId) {
      getLogs();
    }
  }, [currentPage]);

  return (
    <TabPane tabId="site_change_log_tab" style={{}}>
      <Table responsive>
        <thead>
          <tr>
            <th style={styles.tableTitle}>
              {t().site_rental_information__time}
            </th>
            <th style={styles.tableTitle}>{t().site_changlog__user}</th>
            <th style={styles.tableTitle}>{t().site_activity__activity}</th>
            <th style={styles.tableTitle}>{t().site_listing__status}</th>
          </tr>
        </thead>
        <tbody>
          {logs.map((log: any) => (
            <tr key={log?.id}>
              <td>{moment(log?.created_on).format("HH:mm DD/MM/YYYY")}</td>
              <td>{log.full_name}</td>
              <td>{actionName(log?.action_type)}</td>
              <td>{log?.status_name}</td>
            </tr>
          ))}
        </tbody>
      </Table>
      {logs && logs.length < totalLog && (
        <Button
          disabled={isLoadLog}
          color={isLoadLog ? "secondary" : "primary"}
          onClick={loadMoreLogs}
          style={styles.loadMoreButton}
        >
          {isLoadLog ? "Đang tải..." : "Tải thêm"}
        </Button>
      )}
    </TabPane>
  );
}

const styles = {
  loadMoreButton: {
    width: "100%",
    marginTop: 12,
    marginBottom: 12,
  },
  tableTitle: {
    borderWidth: 0,
    borderBottomWidth: 2,
    borderColor: "#263F76",
    color: "#263F76",
    minWidth: 200,
  },
};
